export const SET_DATA = 'MEDIA-PLANNER/SET_DATA'
export const RESET_DATA = 'MEDIA-PLANNER/RESET_DATA'
export const GET_DATA = 'MEDIA-PLANNER/GET_DATA'
